export default "__VITE_ASSET__DNsyvUEI__"